// src/contexts/FavContext.js
import { createContext } from "react";

const FavContext = createContext([]);

export default FavContext;
